import React, {useState, useRef} from 'react';

import {useParams} from "react-router";
import {
    createIndicatorInformation,
    updateIndicatorInformation
} from "../../services/Indicators.service";
import {useUser} from "../../store/providers/app";
import {useMutation, useQueryClient} from "react-query";
import {toast} from "react-toastify";
import {setLog} from "../../services/Logs.service";
import {ModalApp} from "../Modal";
import {Tooltip} from "../Tooltip";

export const InfoPopover = ({label, info, referenceInput}) => {
    const [modal, setModal] = useState(false);
    const [text, setText] = useState('');
    const ref = useRef(null);

    const queryClient = useQueryClient()

    const {id} = useParams()
    const {user} = useUser()

    const handleText = (text) => {
        setText(text)
    }

    const save = async () => {
        const data = {
            "indicator_id": id,
            "user_id": user.id,
            "text": text,
            "reference": referenceInput
        }

        let title = 'UPDATE_INDICATOR_INFORMATION'
        let description = `Editou a informação de ajuda no campo ${label}`

        if (info?.id) {
            data.id = info.id
            await updateIndicatorInformation(data)
        } else {
            await createIndicatorInformation(data)
            title = 'CREATE_INDICATOR_INFORMATION'
            description = `Adicionou a informação de ajuda no campo ${label}`
        }

        setLog({
            'title': title,
            'description': description,
            'username': user.username,
            'indicator_id': id,
        })

    }
    const dataMutation = useMutation(async () => {
            return save()
        }, {
            onSuccess: (res) => {
                toast.success('Salvo com sucesso!');
                queryClient.invalidateQueries(['information_indicator', id])
            },
            onError: (err) => {
                toast.error('Falha na requisição!');
            }
        }
    )

    const handleSave = () => {
        dataMutation.mutate()
    }

    const handleModal = () => {
        setModal(!modal)
    }

    if(!id) return <span />

    return (
        <div ref={ref}>

            { info?.text  && (
                <>
                    <Tooltip label={info?.text}>
                        <span role="button">
                            <i className="bi bi-info-circle-fill text-info"/>
                        </span>
                    </Tooltip>
                </>
            )}

            {user.profile === 1 && (
                <>
                    <Tooltip label="Editar">
                         <span role="button" onClick={handleModal}>
                            <i className="bi bi-pencil-square ms-2" />
                        </span>
                    </Tooltip>

                    <ModalApp
                        show={modal}
                        handleModal={handleModal}
                        closeButton={true}
                        headerTitle="Informações de preenchimento"
                    >
                        <div className="d-flex flex-column gap-2 p-4">
                            <label className="form-label mb-0">{label}</label>
                            <textarea
                                className="form-control"
                                placeholder="Informações de preenchimento"
                                onChange={(e) => handleText(e.target.value)}
                                defaultValue={info?.text}
                                rows={4}
                            />
                            <div className="d-flex justify-content-end gap-2 mt-3 w-100">
                                <button type="button" className="btn btn-light"
                                        onClick={handleModal}>Fechar
                                </button>
                                <button type="button" className="btn  btn-success"
                                        onClick={handleSave}>Salvar
                                </button>
                            </div>
                        </div>
                    </ModalApp>
                </>
            )}
        </div>
    );
}

